import { MouseEventHandler } from 'react';

import {
  Avatar,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from '@chakra-ui/react';
import { observer } from 'mobx-react-lite';

import { useAuth } from '@r-client/shared/feature/auth';
import { Link } from '@r-client/shared/ui/core';

interface IProfileMenuProp {
  appLastUpdated?: string;
  appReleaseVersion?: string;
}

export const ProfileMenu = observer(function ProfileMenu({
  appLastUpdated,
  appReleaseVersion,
}: IProfileMenuProp) {
  const { viewer, signOut } = useAuth();
  const signOutHandler: MouseEventHandler<HTMLElement> = async (e) => {
    e.preventDefault();
    await signOut({ redirectTo: '/' });
  };
  return (
    <Menu autoSelect={false}>
      <MenuButton>
        <Avatar
          size="xs"
          name={`${viewer?.info?.firstName} ${viewer?.info?.lastName}`}
          src={viewer?.info?.avatarUrl ?? undefined}
        />
      </MenuButton>
      <MenuList zIndex={1} m="-6px 0px 0px 15px">
        <MenuItem>
          <Link variant={Link.variants.inherit} href="/settings">
            <Text>Setting</Text>
          </Link>
        </MenuItem>
        <MenuItem>
          <Link
            variant={Link.variants.inherit}
            target="_blank"
            href="https://www.jotform.com/220766111700040"
          >
            <Text>Help and Support</Text>
          </Link>
        </MenuItem>
        {!!appReleaseVersion && !!appLastUpdated && (
          <MenuItem>
            <Link
              variant={Link.variants.inherit}
              target="_blank"
              href={`https://github.com/joinrepublic/r-client/releases/tag/v${appReleaseVersion}`}
            >
              <Text>{`${appLastUpdated} || v${appReleaseVersion}`}</Text>
            </Link>
          </MenuItem>
        )}
        <MenuItem onClick={signOutHandler}>
          <Text>Sign Out</Text>
        </MenuItem>
      </MenuList>
    </Menu>
  );
});
